export type PayType = 'hourly' | 'monthly' | null | undefined;

export const formatMoney = (amount: number, currency: string, locale = 'en'): string => {
  const currencyCode = (currency || 'AED').toUpperCase();

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      maximumFractionDigits: 2
    }).format(amount);
  } catch {
    return `${currencyCode} ${Number(amount).toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    })}`;
  }
};

export const formatPayType = (payType: PayType, t: (key: string) => string): string => {
  if (payType === 'hourly') return t('payTypeHourly');
  if (payType === 'monthly') return t('payTypeMonthly');
  return t('payTypeNotConfigured');
};

export const formatMinutesAsHours = (minutes: number | null | undefined, locale = 'en'): string => {
  if (minutes === null || minutes === undefined) return '—';
  const number = new Intl.NumberFormat(locale, { maximumFractionDigits: 0 });
  if (minutes === 0) return locale.startsWith('ar') ? `${number.format(0)} س ${number.format(0)} د` : '0h 0m';
  const sign = minutes < 0 ? '−' : '';
  const h = Math.floor(Math.abs(minutes) / 60);
  const m = Math.abs(minutes) % 60;
  if (locale.startsWith('ar')) {
    return `${sign}${number.format(h)} س ${number.format(m)} د`;
  }
  return `${sign}${number.format(h)}h ${number.format(m)}m`;
};
